/* eslint-disable @typescript-eslint/no-explicit-any */
import { governmentSettings } from '@/accessors/indexedDB'
import { getUserAttributesFromStore } from '@/modules/miiaFw/MiiaFwCognito'
import { generateHash } from '@/utils/cryptography/cryptography'

/**
 * zipファイルを開く際に設定するパスワードとしてgovernmentSettingsの値からハッシュ値を生成する
 * @param govCode 自治体コード
 * @returns パスワード文字列（ハッシュ値）
 */
export const generatePassword = async (govCode: string): Promise<string> => {
  const governmentSettingsFromIndexedDB = (await governmentSettings.get({
    system: 'disaster-emergency',
    govCode: govCode
  })) as any
  // TODO: governmentSettingのzipファイル用パスワードのプロパティ名が違う場合変更する
  const zipDownloadPassword: string =
    governmentSettingsFromIndexedDB.zipDownloadPassword !== undefined
      ? governmentSettingsFromIndexedDB.zipDownloadPassword
      : ''
  const password = zipDownloadPassword + govCode
  return generateHash(password)
}

/**
 * storeのdisastersからgovCodeを取得し、パスワード生成
 * @returns zipファイルのパスワード
 */
export const getZipPassword = async (): Promise<string> => {
  const attribute = await getUserAttributesFromStore()
  return await generatePassword(attribute.attribute['disaster-commonattr'].govCode)
}
